import React, { useState } from "react";
import PropTypes from "prop-types";
import { Accordion } from "react-accessible-accordion";
import * as classes from "./AccordionSection.module.css";

const AccordionSection = ({ children }) => {
  const [itemOpen, setItemOpen] = useState("");
  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { itemOpen, setItemOpen });
    }
    return child;
  });

  return (
    <Accordion allowZeroExpanded={true} className={classes.accordion}>
      {childrenWithProps}
    </Accordion>
  );
};

AccordionSection.propTypes = {
  children: PropTypes.array.isRequired
};

export default AccordionSection;
